"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _lodash = require("lodash");
var _NavBar = _interopRequireDefault(require("./NavBar"));
require("./Navigation.scss");
require("./fader.scss");
var _fader2 = _interopRequireDefault(require("../../../core/utils/fader"));

/* eslint-disable prettier/prettier */
var Navigation = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inheritsLoose2.default)(Navigation, _React$PureComponent);
  function Navigation() {
    var _this;
    _this = _React$PureComponent.call(this) || this;
    _this.handleNavigationDrawer = function (value) {
      _this.setState({
        hovered: value
      });
    };
    _this.state = {
      hovered: false,
      navPageData: []
    };
    return _this;
  }
  var _proto = Navigation.prototype;
  _proto.componentDidUpdate = function componentDidUpdate() {
    var pageData = this.props.pageData;
    var navPageData = this.state.navPageData;
    var nav = document.querySelector('.cmp-navigation__group');
    var navStatus = !(nav != null && nav.classList.contains('fader-fade')) && (nav == null ? void 0 : nav.clientWidth) > 0;
    if (pageData !== navPageData && !(0, _lodash.isEmpty)(pageData) && navStatus) {
      var navFader = (0, _fader2.default)('cmp-navigation__group', 0, 100);
      this.setState({
        navPageData: pageData
      });
      if (navFader && nav) {
        nav.addEventListener('scroll', navFader);
      }
    }
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    var navFader = (0, _fader2.default)('cmp-navigation__group', 0, 100);
    var nav = document.querySelector('.cmp-navigation__group');
    if (navFader && nav) {
      nav.removeEventListener('scroll', navFader);
    }
  };
  _proto.render = function render() {
    var _this$props = this.props,
      className = _this$props.className,
      pageData = _this$props.pageData,
      config = _this$props.config,
      showDropdown = _this$props.showDropdown,
      labels = _this$props.labels,
      quickOrderUrl = _this$props.quickOrderUrl,
      isHideQuickOrderLink = _this$props.isHideQuickOrderLink,
      isNavigationV2Enabled = _this$props.isNavigationV2Enabled,
      mobileData = _this$props.mobileData,
      mobileV2Config = _this$props.mobileV2Config;
    var isMobile = className !== '';
    var hovered = this.state.hovered;
    var ovarlayClassName = hovered ? 'overlay-container-show' : '';
    return _react.default.createElement("div", {
      className: className + " cmp-header__navigation"
    }, _react.default.createElement("div", {
      className: isMobile ? '' : 'container'
    }, _react.default.createElement("div", {
      className: "navigation"
    }, _react.default.createElement("nav", {
      className: "cmp-navigation " + (isNavigationV2Enabled ? 'cmp-navigation__v2' : '') + " " + (hovered ? 'cmp-navigation--shadow' : '') + " " + (showDropdown ? 'cmp-navigation-arrow' : ''),
      role: "navigation"
    }, _react.default.createElement(_NavBar.default, {
      data: pageData,
      showDropdown: showDropdown,
      handleNavigationDrawer: this.handleNavigationDrawer,
      hovered: hovered,
      isMobile: isMobile,
      config: config,
      labels: labels,
      quickOrderUrl: quickOrderUrl,
      isHideQuickOrderLink: isHideQuickOrderLink,
      isNavigationV2Enabled: isNavigationV2Enabled,
      mobileData: mobileData,
      mobileV2Config: mobileV2Config
    }))), _react.default.createElement("div", {
      className: ovarlayClassName + " cmp-navigation-overlay__container overlay-container"
    })));
  };
  return Navigation;
}(_react.default.PureComponent);
Navigation.defaultProps = {
  className: '',
  config: {},
  showDropdown: false,
  quickOrderUrl: '/#',
  isHideQuickOrderLink: false
};
var _default = Navigation;
exports.default = _default;
module.exports = exports["default"];